import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from "@angular/forms";
import { Component, Injectable, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { EventService } from "src/app/core/services/event.service";
import { ApiService } from "src/app/shared/services/api.service";
import { TranslateService } from "@ngx-translate/core";
import Swal from "sweetalert2";
import {
  NgbDateParserFormatter,
  NgbDateStruct,
  NgbModal,
} from "@ng-bootstrap/ng-bootstrap";
import html2canvas from "html2canvas";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { forkJoin, of } from "rxjs";
import { catchError, map, tap } from "rxjs/operators";
import * as moment from "moment";
import { environment } from "src/environments/environment";

@Injectable()
export class RequestedCancelDateFormatter extends NgbDateParserFormatter {
  parse(value: string): NgbDateStruct | null {
    if (!value) {
      return null;
    }

    const compactValue = value.replace(/\D/g, "");
    if (compactValue.length === 8) {
      return {
        day: Number(compactValue.slice(0, 2)),
        month: Number(compactValue.slice(2, 4)),
        year: Number(compactValue.slice(4, 8)),
      };
    }

    const [day, month, year] = value.split("/").map(Number);
    return day && month && year ? { day, month, year } : null;
  }

  format(date: NgbDateStruct | null): string {
    if (!date) {
      return "";
    }

    return `${String(date.day).padStart(2, "0")}/${String(
      date.month
    ).padStart(2, "0")}/${date.year}`;
  }
}

@Component({
  selector: "app-detal-order",
  templateUrl: "./detal-order.component.html",
  styleUrls: ["./detal-order.component.scss"],
  providers: [
    { provide: NgbDateParserFormatter, useClass: RequestedCancelDateFormatter },
  ],
})
export class DetalOrderComponent implements OnInit {
  params = "";
  phone: Number;
  filter = {
    // location_id: -1,
    status: -1,
    start_date: -1,
    end_date: -1,
  };
  leader = "";
  data = <any>{};
  dataMember = <any>{};
  data1 = <any>{};
  data2 = <any>{};
  listData = [];
  listData1 = [];
  listDataDevice = [];
  listDevices = [];
  id: number = 0;
  pageSize = 10;
  pageIndex = 1;
  totalCount = 0;
  totalCount1 = 2;
  listDataLog = [];
  selectedProvince: any = -1;
  selectedDistrict: any = -1;
  selectedWard: any = -1;
  listProvince: any[] = []; // Danh sách các tỉnh/thành phố
  listDistrict: any[] = []; // Danh sách các quận/huyện
  listWard: any[] = []; // Danh sách các xã/phường
  formData2: FormGroup;
  formData: FormGroup;
  tableName: string = "workspaces/";
  tableName2 = "devices/active";
  qrCodeValue: string;
  device_id_new;
  range = new FormGroup({
    start: new FormControl(),
    end: new FormControl(),
  });
  minTransactionDate = new Date(2026, 0, 1);
  startDate;
  endDate;
  typePhone = [
    { value: "delivery_late", label: "Đã gọi KH do giao chậm" },
    { value: "wrong_queue", label: "Đã gọi KH nhầm luồng" },
    { value: "error_device", label: "Đã gọi KH lỗi Loa" },
    { value: "orther", label: "Khác" },
  ];
  customerServices;
  typeShip = [
    { value: "delivered", label: "Hoàn thành" },
    { value: "cancel", label: "Thất bại" },
  ];
  typeUnit = [
    { value: "vtp", label: "ViettelPost" },
    { value: "ghn", label: "Giao hàng nhanh" },
    { value: "ahamove", label: "Ahamove" },
    { value: "other", label: "Khác" },
  ];
  typeUnitDone = [
    { value: "Viettel post", label: "Viettel post" },
    { value: "Other", label: "Khác" },
  ];
  role = JSON.parse(localStorage.getItem("currentUser")).role;

  buildRmInfoLine(rmInfo: any): string {
    if (!rmInfo) {
      return "";
    }

    const parts = [rmInfo.code_rm, rmInfo.full_name, rmInfo.phone, rmInfo.email]
      .filter((value) => !!value)
      .map((value) => String(value).trim())
      .filter((value) => value.length > 0);

    return parts.join(" - ");
  }

  buildRmAgencyLine(rmInfo: any): string {
    if (!rmInfo) {
      return "";
    }

    const parts = [rmInfo.branch, rmInfo.agency_name]
      .filter((value) => !!value)
      .map((value) => String(value).trim())
      .filter((value) => value.length > 0);

    return parts.join(" - ");
  }

  private joinAddressParts(parts: any[]): string {
    return parts
      .filter((value) => !!value)
      .map((value) => String(value).trim())
      .filter((value) => value.length > 0)
      .join(", ");
  }

  buildDirectAddress(data: any): string {
    if (!data) {
      return "";
    }
    return this.joinAddressParts([
      data.terminal_address,
      data.terminal_ward,
      data.terminal_district,
      data.terminal_province,
    ]);
  }

  buildShipperAddress(data: any): string {
    if (!data) {
      return "";
    }
    return this.joinAddressParts([
      data.address,
      data.to_ward_name,
      data.to_district_name,
      data.to_province_name,
    ]);
  }

  customerTypeMap: any = {
    CN: { label: "Cá nhân", class: "badge-primary" },
    DN: { label: "Doanh nghiệp", class: "badge-secondary" },
    HKD: { label: "Hộ kinh doanh", class: "badge-info" },
    "DN-HKD": { label: "DN - HKD", class: "badge-warning" },
  };

  getCustomerTypeLabel(type: string): string {
    return this.customerTypeMap[type]?.label || type || "Chưa xác định";
  }

  getCustomerTypeClass(type: string): string {
    return this.customerTypeMap[type]?.class || "badge-dark";
  }

  getDiscountPercent(): number {
    const original = Number(this.data?.original_price) || 0;
    const discounted = Number(this.data?.discounted_price) || 0;
    if (!original || discounted >= original) {
      return 0;
    }
    return Math.round((1 - discounted / original) * 100);
  }

  orderStatusClass(status: string): string {
    const value = (status || "").toString().toLowerCase();
    if (
      value.includes("hủy") ||
      value.includes("lỗi") ||
      value.includes("thất bại")
    ) {
      return "status-pill--danger";
    }
    if (
      value.includes("giao") ||
      value.includes("hoàn thành") ||
      value.includes("thành công")
    ) {
      return "status-pill--success";
    }
    return "";
  }

  formatPhoneDisplay(phone: any): string {
    const digits = String(phone || "").replace(/\D/g, "");
    if (digits.length !== 10) {
      return phone || "";
    }
    return `${digits.slice(0, 4)}${digits.slice(4, 7)}${digits.slice(7)}`;
  }

  formatLogDateTime(value: string): { date: string; time: string } {
    if (!value) {
      return { date: "", time: "" };
    }
    const parsed = moment(value);
    if (!parsed.isValid()) {
      return { date: value, time: "" };
    }
    return { date: parsed.format("DD/MM/YYYY"), time: parsed.format("HH:mm") };
  }
  makeForm(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      id: [data.id],
      model: [data.model, [Validators.required]],
      serial_number: [data.serial_number, [Validators.required]],
      serial_number_new: [data.serial_number_new],
      serial_number_old: [data.serial_number_old],
      version: [data.version, [Validators.required]],
      userId: [data.userId, [Validators.required]],
      idWs: [data.idWs, [Validators.required]],
      typeUpdate: [data.typeUpdate],
      note: [data.note],
      shipNote: [data.shipNote],
      orderCode: [data.orderCode],
      shipDate: [data.shipDate],
      deliveredDate: [data.deliveredDate],
      is_warranty: [data.is_warranty || false],
      orderType: [data.orderType],
      sim4g_imsi: "",
      network_provider: "",
      cs_take_care: [[]],
      reason: [null, Validators.required],
      is_recalled: [0],
      reuse_category: [null],
      reuse_category_reason: [null],
      returned_date: [null],
      recalled_image: [null],
      recalled_video: [null],
      device_link_request_id: [data.device_link_request_id],
      // currency: [data.currency || 'VND'],
    });
  }

  makeFormOnline(d?) {
    let data = d ? d : <any>{};
    // A field is only required when the order doesn't already carry a
    // value for it (prefilled from the existing delivery info) - see
    // onChangeOnline().
    return this.formBuilder.group({
      id: [data.id],
      recipient_name: [
        data.recipient_name,
        data.recipient_name ? [] : [Validators.required],
      ],
      phone_number: [
        data.phone_number,
        [
          ...(data.phone_number ? [] : [Validators.required]),
          Validators.pattern(/^(03|05|07|08|09)\d{8}$/),
          Validators.minLength(10),
          Validators.maxLength(10),
        ],
      ],
      province: [data.province, data.province ? [] : [Validators.required]],
      district: [data.district, data.district ? [] : [Validators.required]],
      ward: [data.ward, data.ward ? [] : [Validators.required]],
      // delivery_method: [data.delivery_method],
      specific_address: [
        data.specific_address,
        data.specific_address ? [] : [Validators.required],
      ],
    });
  }
  // public person
  constructor(
    public eventService: EventService,
    private apiService: ApiService,
    public activatedRoute: ActivatedRoute,
    private translateService: TranslateService,
    private modalService: NgbModal,
    public formBuilder: FormBuilder,
    private http: HttpClient,
    private sanitizer: DomSanitizer,
    private router: Router
  ) {}
  makeFormChange(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      serial_number: [{ value: "", disabled: true }],
      serial_number_new: ["", Validators.required],
      reason: ["", Validators.required],
      note: [""],
    });
  }
  reasonOptions = [
    { value: "LOST_BY_CARRIER", label: "Mất do đơn vị vận chuyển" },
    { value: "WARRANTY", label: "Bảo hành" },
    { value: "OTHER", label: "Khác" },
  ];
  ngOnInit(): void {
    this.id = this.activatedRoute.snapshot.params["id"];
    this.fetchData();
    this.fetchDataLog();
    this.fetchDataDevive();
    this.getProvinces();
    this.fetchDataCSKH();
    this.range.valueChanges.subscribe((rangeValues) => {
      const formatDate = (date: Date | null) => {
        if (!date) return null;
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      };
      this.startDate = formatDate(rangeValues.start);
      this.endDate = formatDate(rangeValues.end);
    });
  }
  reasonDelete: string = "";
  cancelType;
  requestedCancelDate: string = "";
  maxRequestedCancelDate: NgbDateStruct = this.getTodayAsNgbDate();

  private getTodayAsNgbDate(): NgbDateStruct {
    const today = new Date();
    return {
      year: today.getFullYear(),
      month: today.getMonth() + 1,
      day: today.getDate(),
    };
  }

  private formatDateForApi(date: string): string {
    const [firstPart, secondPart, thirdPart] = (date || "").split("-");
    if (firstPart?.length === 4 && secondPart && thirdPart) {
      return `${firstPart}-${secondPart.padStart(2, "0")}-${thirdPart.padStart(2, "0")}`;
    }

    const [day, month, year] = [firstPart, secondPart, thirdPart];
    return year && month && day
      ? `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`
      : "";
  }

  onRequestedCancelDateInput(event: Event): void {
    const input = event.target as HTMLInputElement;
    const digits = input.value.replace(/\D/g, "").slice(0, 8);
    const formattedDate = [
      digits.slice(0, 2),
      digits.slice(2, 4),
      digits.slice(4, 8),
    ]
      .filter((part) => part.length > 0)
      .join("/");

    if (input.value !== formattedDate) {
      input.value = formattedDate;
    }
  }
  onCancelRenewal(data) {
    Swal.fire({
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn hủy gia hạn đơn hàng?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "fff",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
      customClass: {
        icon: "my-custom-icon-class",
      },
    }).then((result) => {
      if (result.value) {
        this.apiService
          .postItem(`customer-orders/admin/${this.id}/cancel-autodebit`, {})
          .subscribe(
            (res) => {
              this.modalService.dismissAll();
              this.fetchData();
              this.fetchDataLog();
              this.fetchDataDevive();
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Tạo yêu cầu hủy thành công")
              );
            },
            (error) => {
              if (error) {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant(error)
                );
              } else {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Tạo thất bại")
                );
              }
            }
          );
        this.eventService.setLoading(false);
      }
    });
  }
  onDelete() {
    Swal.fire({
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn hủy đơn hàng?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "red",
      cancelButtonColor: "fff",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
      customClass: {
        icon: "my-custom-icon-class",
      },
    }).then((result) => {
      if (result.value) {
        const data = {
          order_id: this.formData.value.id,
          reason: this.reasonDelete,
          type_cancel: this.cancelType,
          requested_cancel_date: this.formatDateForApi(
            this.requestedCancelDate
          ),
        };
        this.apiService.postItem("order-cancel", data).subscribe(
          (res) => {
            this.modalService.dismissAll();
            this.fetchData();
            this.fetchDataLog();
            this.fetchDataDevive();
            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Tạo yêu cầu hủy thành công")
            );
          },
          (error) => {
            if (error) {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant(error)
              );
            } else {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant("Tạo thất bại")
              );
            }
          }
        );
        this.eventService.setLoading(false);
      }
    });
  }
  onCancelOrder(data, content) {
    this.formData = this.makeForm(data);
    this.reasonDelete = "";
    this.cancelType = "";
    this.requestedCancelDate = "";
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  // Cập nhật địa chỉ
  // getProvinces() {
  //   this.http.get("https://partnerdev.viettelpost.vn/v2/categories/listProvinceById?provinceId=-1")
  //     .subscribe((response: any) => {
  //       this.listProvince = response.data;
  //     });

  // }

  // onProvinceChange(provinceId) {
  //   this.http.get("https://partnerdev.viettelpost.vn/v2/categories/listDistrict?provinceId=" + provinceId?.PROVINCE_ID)
  //     .subscribe((response: any) => {
  //       this.listDistrict = response.data;
  //     });
  //   this.listWard = []

  // }

  // onDistrictChange(districtId) {
  //   this.http.get("https://partnerdev.viettelpost.vn/v2/categories/listWards?districtId=" + districtId.DISTRICT_ID)
  //     .subscribe((response: any) => {
  //       this.listWard = response.data;
  //     });
  // }
  getProvinces() {
    this.apiService.getList("viettel-post/province?provinceId=-1").subscribe({
      next: (res) => {
        this.listProvince = res;
      },
    });
  }

  onProvinceChange(provinceId) {
    this.apiService
      .getList("viettel-post/district?provinceId=" + provinceId?.PROVINCE_ID)
      .subscribe({
        next: (res) => {
          this.listDistrict = res;
        },
      });
    this.listWard = [];
  }

  onDistrictChange(districtId) {
    this.apiService
      .getList("viettel-post/ward?districtId=" + districtId.DISTRICT_ID)
      .subscribe({
        next: (res) => {
          this.listWard = res;
        },
      });
  }

  fetchDataDevive() {
    this.apiService.getList("device-stock").subscribe({
      next: (res) => {
        this.listDevices = res.metadata["deviceStocks"]
          ? res.metadata["deviceStocks"]
          : [];
      },
    });
  }
  countMember: number;
  countTransaction: number;
  deviceName;
  onEdit(data, content) {
    console.log(data);
    this.formData = this.makeForm(data);
    this.deviceName = data.serial_number;
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
    this.viewQRcode(data);
  }
  onUpdate(data, content) {
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  onChange(data, content) {
    console.log(data);
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  onChangeOrderType(data, content) {
    console.log(data);
    this.formData = this.makeForm(data);
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  dataHistory;
  cumulativeSP() {
    const value = this.formData.value;
    const payload = {
      phone: this.phone,
      oldSerialNumber: value.serial_number_old,
      newSerialNumber: value.serial_number,
    };
    // console.log("Payload gửi API:", payload);
    this.apiService
      .postItem("device-subscriptions/extend-duration", payload)
      .subscribe({
        next: () => {
          this.apiService.showToastMobile("success", "Cộng dồn thành công!");
          this.modalService.dismissAll();
        },
        error: (e) => {
          this.apiService.showToastMobile("error", e || "Có lỗi xảy ra!");
        },
      });
  }
  onDetailHistory(data, content) {
    if (data?.shipping_unit == "GHN") {
      this.apiService
        .getList("ghn-order-callback?order_id=" + data.id)
        .subscribe({
          next: (res) => {
            this.dataHistory = res.metadata ? res.metadata.delyveryDetails : [];
          },
        });
    } else {
      this.apiService
        .getList("customer-orders/delivery-details/vtp?order_id=" + data.id)
        .subscribe({
          next: (res) => {
            this.dataHistory = res.metadata ? res.metadata.delyveryDetails : [];
          },
        });
    }
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  dataTransaction;
  getDataTransaction() {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        `transactions?page=${this.pageIndex}&limit=${this.pageSize}&startDate=${this.startDate}&endDate=${this.endDate}&serialNumber=${this.deviceName}`
      )
      .subscribe({
        next: (res) => {
          this.dataTransaction = res["transactions"] ? res["transactions"] : "";
          this.totalCount = res["pagination"]["totalCount"]
            ? res["pagination"]["totalCount"]
            : "";
          this.eventService.setLoading(false);
        },
        error: () => {
          this.eventService.setLoading(false);
        },
      });
  }
  packageDetail;
  lastPackageDetail;
  private currentDate: any;
  registeredStart: any;
  registeredEnd: any;
  giftedStart: any;
  giftedEnd: any;

  overallStart: any;
  overallEnd: any;

  registeredBarWidth = "0%";
  giftedBarWidth = "0%";
  registeredGradient = "";
  giftedGradient = "";
  hasGiftedPackage = false;
  onRenewHistory(data, content) {
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        `service-package-sub/get-detail-sub/${data?.device_subscription_id}`
      )
      .subscribe({
        next: (res) => {
          this.listData = res.metadata["data"] || [];

          this.listData = this.listData.map((i) => {
            const activationDate = moment(i.activation_date);
            return {
              ...i,
              activation_date: moment(i.activation_date).format("DD/MM/YYYY"),
              expiration_date: moment(i.expiration_date).format("DD/MM/YYYY"),
              registeredEnd: activationDate
                .clone()
                .add(i.original_duration, "months")
                .format("DD/MM/YYYY"),
              giftedStart: activationDate
                .clone()
                .add(i.original_duration, "months")
                .format("DD/MM/YYYY"),
            };
          });
          this.packageDetail = res.metadata["data"]
            ? res.metadata["data"][0] || null
            : null;
          if (this.packageDetail?.status == "Expired") {
            this.packageDetail = null;
          }
          this.lastPackageDetail = res.metadata["data"]
            ? res.metadata["data"][0] || null
            : null;
          if (this.packageDetail) {
          } else {
            this.packageDetail = res.metadata["data"]
              ? res.metadata["data"][0]
              : null;
          }
          if (this.packageDetail) {
            const activationDate = moment(this.packageDetail.activation_date);
            const expirationDate = moment(this.packageDetail.expiration_date);

            if (!activationDate.isValid() || !expirationDate.isValid()) {
              console.error(
                "Invalid date format:",
                this.packageDetail.activation_date,
                this.packageDetail.expiration_date
              );
              this.eventService.setLoading(false);
              return;
            }

            this.currentDate = moment();
            this.overallStart = activationDate.clone();
            this.registeredStart = this.overallStart.clone();
            this.registeredEnd = this.registeredStart
              .clone()
              .add(this.packageDetail.original_duration, "months");
            this.giftedStart = this.registeredEnd.clone();
            this.giftedEnd = this.overallStart
              .clone()
              .add(this.packageDetail.duration, "months");

            this.overallEnd = expirationDate.clone();

            this.calculateTimeline();
            this.packageDetail = {
              ...this.packageDetail,
              expiration_date: moment(this.packageDetail.expiration_date)
                .add(1, "day")
                .format("DD/MM/YYYY"),
              activation_date: moment(
                this.packageDetail.activation_date
              ).format("DD/MM/YYYY"),
              discounted_price:
                this.packageDetail.discounted_price?.toLocaleString("vi-VN"),
              registeredEnd: moment(this.registeredEnd).format("DD/MM/YYYY"),
              giftedStart: moment(this.giftedStart).format("DD/MM/YYYY"),
            };
          }

          this.eventService.setLoading(false);
        },
        error: (err) => {
          console.error("Error fetching data:", err);
          this.eventService.setLoading(false);
        },
      });

    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }

  setDetail(item) {
    this.packageDetail = {
      ...item,
    };
    const activationDate = moment(item.activation_date, "DD/MM/YYYY");
    const expirationDate = moment(item.expiration_date, "DD/MM/YYYY");

    if (!activationDate.isValid() || !expirationDate.isValid()) {
      console.error(
        "Invalid date format:",
        this.packageDetail.activation_date,
        this.packageDetail.expiration_date
      );
      this.eventService.setLoading(false);
      return;
    }

    this.currentDate = moment();
    this.overallStart = activationDate.clone();
    this.registeredStart = this.overallStart.clone();
    this.registeredEnd = this.registeredStart
      .clone()
      .add(this.packageDetail.original_duration, "months");
    this.giftedStart = this.registeredEnd.clone();
    this.giftedEnd = this.overallStart
      .clone()
      .add(this.packageDetail.duration, "months");

    this.overallEnd = expirationDate.clone();

    this.calculateTimeline();
  }
  calculateTimeline(): void {
    if (
      !this.overallStart ||
      !this.overallEnd ||
      !this.registeredStart ||
      !this.registeredEnd
    ) {
      console.error("Timeline variables are not initialized correctly");
      return;
    }

    const totalDuration =
      this.overallEnd.valueOf() - this.overallStart.valueOf();

    const registeredDuration =
      this.registeredEnd.valueOf() - this.registeredStart.valueOf();
    this.registeredBarWidth = `${(registeredDuration / totalDuration) * 100}%`;

    const registeredTotalTime =
      this.registeredEnd.valueOf() - this.registeredStart.valueOf();
    const registeredElapsed = Math.min(
      Math.max(this.currentDate.valueOf() - this.registeredStart.valueOf(), 0),
      registeredTotalTime
    );
    const registeredFadePercent =
      (registeredElapsed / registeredTotalTime) * 100;
    this.registeredGradient = this.calculateGradient(
      "#0052cc",
      registeredFadePercent
    );

    this.hasGiftedPackage = !!(
      this.giftedStart &&
      this.giftedEnd &&
      this.giftedEnd.valueOf() > this.giftedStart.valueOf()
    );

    if (this.hasGiftedPackage) {
      const giftedDuration =
        this.giftedEnd.valueOf() - this.giftedStart.valueOf();
      this.giftedBarWidth = `${(giftedDuration / totalDuration) * 100}%`;

      const giftedTotalTime =
        this.giftedEnd.valueOf() - this.giftedStart.valueOf();
      const giftedElapsed = Math.min(
        Math.max(this.currentDate.valueOf() - this.giftedStart.valueOf(), 0),
        giftedTotalTime
      );
      const giftedFadePercent = (giftedElapsed / giftedTotalTime) * 100;
      this.giftedGradient = this.calculateGradient(
        "#28a745",
        giftedFadePercent
      );
    } else {
      this.giftedBarWidth = "0%";
      this.giftedGradient = "";
    }
  }

  private calculateGradient(color: string, fadePercent: number): string {
    const fadedColor = `${color}4D`;
    if (fadePercent <= 0) {
      return color;
    }
    if (fadePercent >= 100) {
      return fadedColor;
    }
    return `linear-gradient(to right, ${fadedColor} ${fadePercent}%, ${color} ${fadePercent}%)`;
  }

  onSearchTransaction(data, content) {
    this.formData = this.makeForm(data);
    this.deviceName = data.serial_number;
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });
  }
  goBack() {
    this.router.navigate(["/orders-manager"], {
      queryParamsHandling: "preserve",
    });
  }

  onChangeOnline(data, content) {
    this.submitted = false;
    const isShipper = data.delivery_method === "shipper";
    const recipientName = isShipper ? data.customer_name : data.full_name;
    const phoneNumber = isShipper ? data.phone : data.user_phone;
    const specificAddress = isShipper ? data.address : data.terminal_address;
    const provinceName = isShipper ? data.to_province_name : data.terminal_province;
    const districtName = isShipper ? data.to_district_name : data.terminal_district;
    const wardName = isShipper ? data.to_ward_name : data.terminal_ward;

    this.formData = this.makeFormOnline({
      id: data.id,
      recipient_name: recipientName,
      phone_number: phoneNumber,
      specific_address: specificAddress,
    });

    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
    });

    this.prefillDeliveryAddress(provinceName, districtName, wardName);
  }

  private matchByName(list: any[], key: string, name: string): any {
    if (!list?.length || !name) {
      return null;
    }
    return list.find(
      (item) =>
        String(item[key] || "").trim().toLowerCase() ===
        name.trim().toLowerCase()
    );
  }

  // Tries to resolve the order's existing province/district/ward text into
  // the option objects the ng-select controls need, so an order that
  // already has delivery info doesn't force the user to reselect it. If a
  // level can't be matched, its control is left empty and required.
  private prefillDeliveryAddress(
    provinceName: string,
    districtName: string,
    wardName: string
  ) {
    const province = this.matchByName(
      this.listProvince,
      "PROVINCE_NAME",
      provinceName
    );
    if (!province) {
      return;
    }
    this.formData.get("province").setValue(province);
    this.formData.get("province").clearValidators();
    this.formData.get("province").updateValueAndValidity();

    this.apiService
      .getList("viettel-post/district?provinceId=" + province.PROVINCE_ID)
      .subscribe({
        next: (res: any) => {
          this.listDistrict = res;
          const district = this.matchByName(
            this.listDistrict,
            "DISTRICT_NAME",
            districtName
          );
          if (!district) {
            return;
          }
          this.formData.get("district").setValue(district);
          this.formData.get("district").clearValidators();
          this.formData.get("district").updateValueAndValidity();

          this.apiService
            .getList("viettel-post/ward?districtId=" + district.DISTRICT_ID)
            .subscribe({
              next: (res2: any) => {
                this.listWard = res2;
                const ward = this.matchByName(
                  this.listWard,
                  "WARDS_NAME",
                  wardName
                );
                if (!ward) {
                  return;
                }
                this.formData.get("ward").setValue(ward);
                this.formData.get("ward").clearValidators();
                this.formData.get("ward").updateValueAndValidity();
              },
            });
        },
      });
  }
  listMember = [];
  flagDownQr = false;
  // viewQRcode(dataQR: any): Promise<string> {
  //   return new Promise((resolve, reject) => {
  //     this.qrCodeValue = "";
  //     this.flagDownQr = false;
  viewQRcode(dataQR: any): Promise<string> {
    return new Promise((resolve, reject) => {
      this.qrCodeValue = "";
      this.flagDownQr = false;
      this.apiService
        .postItem("devices/get-qrstring", {
          serial_number: dataQR.serial_number,
        })
        .subscribe({
          next: (res) => {
            this.qrCodeValue = res["metadata"]["qr_string"]
              ? res["metadata"]["qr_string"]
              : "";
            this.flagDownQr = true;
            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Tạo QR thành công")
            );
            this.eventService.setLoading(false);
            resolve(this.qrCodeValue);
          },
          error: (e) => {
            if (e) {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant(e)
              );
            } else {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant("Tạo QR thất bại")
              );
            }
            this.eventService.setLoading(false);
            reject(e);
          },
        });
    });
  }

  removeWhitespace() {
    const qrElement = document.querySelector(".custom-qr-code") as HTMLElement;
    if (qrElement) {
      qrElement.style.margin = "0"; // Đảm bảo không có margin
      qrElement.style.padding = "0"; // Đảm bảo không có padding
    }
  }
  isWebView() {
    const userAgent = navigator.userAgent;

    return (
      userAgent.indexOf("FBAN") > -1 ||
      userAgent.indexOf("FBAV") > -1 ||
      window.ReactNativeWebView ||
      userAgent.indexOf("wv") > -1 ||
      userAgent.indexOf("WebView") > -1 ||
      (userAgent.indexOf("Android") > -1 && userAgent.indexOf("wv") > -1)
    );
  }
  downloadQRCode() {
    const elementToDownload =
      document.querySelector(".qr-with-text").parentElement;

    if (elementToDownload) {
      html2canvas(elementToDownload as HTMLElement).then((canvas) => {
        const qrUrl = canvas.toDataURL("image/png");

        if (this.isWebView()) {
          if (window.ReactNativeWebView) {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({ action: "download", url: qrUrl })
            );
          }
        } else {
          const link = document.createElement("a");
          link.href = qrUrl;
          link.download = `QR_Code_${this.deviceName}.png`;
          link.click();
        }
      });
    } else {
      console.error("Không tìm thấy phần tử.");
    }
  }
  printQRCode() {
    // Lấy phần tử cần in
    const elementToPrint =
      document.querySelector(".qr-with-text")?.parentElement;

    if (!elementToPrint) {
      console.error("Không tìm thấy phần tử để in.");
      return;
    }

    html2canvas(elementToPrint).then((canvas) => {
      const qrUrl = canvas.toDataURL("image/png");

      const printWindow = window.open("", "_blank");
      printWindow?.document.write(`
        <html>
          <head>
            <title>In QR Code</title>
            <style>
              @media print {
                body {
                  margin: 0;
                  padding: 0;
                }
                .print-container {
                  text-align: center;
                  width: 100%;
                  max-width: 450px; 
                  // padding-top: 10px;
                }
                img {
                  // width: 55mm;
                  // height: 55mm;
                  // object-fit: contain;
                  width: 100%; 
                  height: auto;

                }
                @page {
                  margin: 0;
                }
              }
            </style>
          </head>
          <body>
            <div class="print-container">
              <img src="${qrUrl}" />
            </div>
          </body>
        </html>
      `);

      // printWindow?.document.write(`
      //   <html>
      //     <head>
      //       <title>In QR Code</title>
      //       <style>
      //         @media print {
      //           body {
      //             margin: 0;
      //             padding: 0;
      //           }
      //           .print-container {
      //             text-align: center;
      //             width: 100%;
      //             padding-top: 10px;
      //           }
      //           img {
      //             width: 55mm;
      //             height: 55mm;
      //             object-fit: contain;
      //           }
      //           @page {
      //             margin: 0;
      //           }
      //         }
      //       </style>
      //     </head>
      //     <body>
      //       <div class="print-container">
      //         <img src="${qrUrl}" />
      //       </div>
      //     </body>
      //   </html>
      // `);
      printWindow?.document.close();
      printWindow?.addEventListener("load", () => {
        printWindow?.print();
        printWindow?.close();
      });
    });
  }
  serviceTypeMap: any = {
    normal: "Đơn thường",
    affiliate: "Đơn affiliate",
    give_away: "Đơn tặng",
  };

  private formatDateYmd(value: string | Date): string {
    if (!value) {
      return "";
    }
    if (typeof value === "string") {
      if (value.includes("/")) {
        const [day, month, year] = value.split("/");
        if (day && month && year) {
          return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
        }
      }
      if (value.includes("-")) {
        return value.slice(0, 10);
      }
      return value;
    }
    return value.toISOString().slice(0, 10);
  }

  getMinDeliveredDate(): string {
    return this.formatDateYmd(this.formData?.value?.shipDate);
  }

  isDeliveryDateInvalid(): boolean {
    const shipDate = this.formatDateYmd(this.formData?.value?.shipDate);
    const deliveredDate = this.formatDateYmd(
      this.formData?.value?.deliveredDate
    );

    if (!shipDate || !deliveredDate) {
      return false;
    }

    return deliveredDate < shipDate;
  }

  updateDelivered() {
    if (this.isDeliveryDateInvalid()) {
      this.apiService.showToastMobile(
        "error",
        this.translateService.instant(
          "Ngày giao hàng phải lớn hơn hoặc bằng ngày gửi hàng"
        )
      );
      return;
    }

    const data = {
      shippingUnit: this.formData.value.shipNote,
      shippingDate: this.formatDateYmd(this.formData.value.shipDate),
      deliveryDate: this.formatDateYmd(this.formData.value.deliveredDate),
      orderCode: this.formData.value.orderCode,
      note: this.formData.value.note,
    };

    this.apiService
      .postItem(`customer-orders/${this.data.id}/delivered`, data)
      .subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Cập nhật thành công")
          );
          this.modalService.dismissAll();
          this.fetchDataLog();
          this.fetchData();
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Cập nhật thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  // CSKH take care

  getCsTakeCare(data: any): string {
    return data?.cs_take_care?.length
      ? data.cs_take_care.map((item: any) => item.cs_name).join(", ")
      : "Chưa có";
  }

  updateOrder() {
    const data = {
      customerOrderId: this.data.id,
      action: this.formData.value.typeUpdate,
      note: this.formData.value.note,
    };
    this.apiService.postItem("cs-log", data).subscribe({
      next: (res: any) => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Cập nhật thành công")
        );
        this.modalService.dismissAll();
        this.fetchDataLog();
        this.fetchData();
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Cập nhật thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  updateOrderCSKH() {
    const data = {
      note: this.formData.value.note,
      csUserIds: this.formData.value.cs_take_care,
    };
    this.apiService
      .postItem(`customer-orders/${this.data.id}/cs/assign`, data)
      .subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Cập nhật CSKH thành công")
          );
          this.modalService.dismissAll();
          this.fetchDataLog();
          this.fetchData();
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Cập nhật CSKH thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  orderCode;
  //Mã đơn hàng
  updateCodeShip() {
    const data = {
      order_code: this.orderCode,
      is_warranty: this.formData.value.is_warranty,
      shipping_unit: this.formData.value.shipNote,
    };
    this.apiService
      .changeStatus("customer-orders", this.data.id, data)
      .subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Cập nhật mã đơn thành công")
          );
          this.fetchData();
          this.fetchDataLog();
          this.fetchDataDevive();
          this.modalService.dismissAll();
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Cập nhật mã đơn thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  orderType;

  //Loại đơn
  updateOrderTypeHandle() {
    this.apiService
      .changeStatus("customer-orders/order-type", this.data.id, {
        orderType: this.orderType,
      })
      .subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Cập nhật loại đơn thành công")
          );
          this.fetchData();
          this.fetchDataLog();
          this.fetchDataDevive();
          this.modalService.dismissAll();
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Cập nhật loại đơn thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }

  // Thêm tháng sử dụng
  onChangeTime(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn thêm 1 tháng sử dụng?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        const dataPost = {
          customer_order_id: data.id,
          monthAdd: 1,
        };
        this.apiService
          .postItem("device-subscription/extra-month", dataPost)
          .subscribe({
            next: (res: any) => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Thêm 1 tháng thành công")
              );
              this.fetchData();
              this.fetchDataLog();
            },
            error: (e) => {
              if (e) {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant(e)
                );
              } else {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Thêm 1 tháng thất bại")
                );
              }
              this.eventService.setLoading(false);
            },
          });
      }
    });
  }
  onSubtractTime(data) {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant(
        "Bạn có chắc chắn muốn trừ thời hạn gói dịch vụ?"
      ),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        const dataPost = {
          serialNumber: data.serial_number,
          newCustomerOrderId: this.data.id,
        };
        this.apiService
          .postItem("device-subscriptions/reduce-duration", dataPost)
          .subscribe({
            next: (res: any) => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Thành công")
              );
              this.fetchData();
              this.fetchDataLog();
            },
            error: (e) => {
              this.apiService.showToastMobile(
                "error",
                this.translateService.instant(e || "Thêm 1 tháng thất bại")
              );

              this.eventService.setLoading(false);
            },
          });
      }
    });
  }
  order_type;
  mb_reference_number;
  fetchData() {
    this.eventService.setLoading(true);
    this.apiService.getList("cs/customer-orders/" + this.id).subscribe({
      next: (res) => {
        this.data = res.metadata;
        this.mb_reference_number = this.data.mb_reference_number;
        this.phone = this.data.user_phone;
        this.order_type = this.data.order_type;
        this.listDataDevice = this.data?.devices || [];
        if (this.listDataDevice.length > 0) {
          forkJoin(
            this.listDataDevice.map((device, index) =>
              this.apiService
                .apiPostToPaydee("prod/loamb/client-status", {
                  clientID: device.serial_number,
                  token: device.token,
                  partner_id: device.user_id,
                })
                .pipe(
                  tap((statusRes: any) => {
                    this.listDataDevice[index].connectedStatus =
                      statusRes.connectedStatus;
                  }),
                  catchError((err) => {
                    this.listDataDevice[index].connectedStatus = "Unknown";
                    return of(null);
                  })
                )
            )
          ).subscribe({
            next: () => {
              this.eventService.setLoading(false);
            },
            error: () => {
              this.eventService.setLoading(false);
            },
          });
        } else {
          this.eventService.setLoading(false);
        }
      },
      error: (err) => {
        this.eventService.setLoading(false);
      },
    });
  }
  fetchDataCSKH() {
    this.apiService.getList("users/switchboard?page=1&limit=50").subscribe({
      next: (res) => {
        this.customerServices = res?.metadata?.users;
      },
      error: (err) => {
        this.eventService.setLoading(false);
      },
    });
  }
  fullname = JSON.parse(localStorage.getItem("currentUser")).full_name;

  fetchDataLog() {
    // this.eventService.setLoading(true)
    this.apiService
      .getList(
        "cs/log" +
          `?orderId=${this.id}&page=${this.pageIndex}&limit=${this.pageSize}`
      )
      .subscribe({
        next: (res) => {
          // console.log(res);
          this.listDataLog = (res.metadata.logOrders || []).map((log) => ({
            ...log,
            noteDiffs: this.parseNoteDiffs(log.note),
          }));
          this.checkRecallEvidenceForLogs(this.listDataLog);
          this.totalCount = res.metadata.pagination.totalCount
            ? res.metadata.pagination.totalCount
            : "";
          // this.eventService.setLoading(false)
        },
      });
  }

  // Some log notes are a JSON string describing each changed field
  // (e.g. '[{"field":"customer_name","label":"Tên người nhận","old":"A","new":"B"}]').
  // When it parses to that shape, render it as a readable diff list instead
  // of a raw JSON blob; otherwise fall back to showing the note as plain text.
  parseNoteDiffs(
    note: string
  ): { field?: string; label?: string; old?: any; new?: any }[] | null {
    if (!note) {
      return null;
    }
    const trimmed = note.trim();
    if (!trimmed.startsWith("[") && !trimmed.startsWith("{")) {
      return null;
    }
    try {
      const parsed = JSON.parse(trimmed);
      const list = Array.isArray(parsed) ? parsed : [parsed];
      const isDiffShape = list.every(
        (item) =>
          item && typeof item === "object" && ("label" in item || "field" in item)
      );
      return isDiffShape && list.length ? list : null;
    } catch {
      return null;
    }
  }
  createOrder() {
    const data = {
      orderId: this.data.id,
    };

    this.apiService.postItem("electronic-invoice/release", data).subscribe({
      next: (res: any) => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Tạo hoá đơn thành công")
        );
        this.fetchData();
        this.modalService.dismissAll();
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Tạo hoá đơn thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  exportOrder() {
    this.apiService
      .getList("electronic-invoice?invoiceNo=" + this.data.invoice_no)
      .subscribe({
        next: (res: any) => {
          const metadata = res.metadata;
          if (metadata && metadata.fileToBytes && metadata.fileName) {
            const linkSource = `data:application/pdf;base64,${metadata.fileToBytes}`;
            const downloadLink = document.createElement("a");
            const fileName = metadata.fileName;

            downloadLink.href = linkSource;
            downloadLink.download = fileName;
            downloadLink.click();

            this.apiService.showToastMobile(
              this.translateService.instant("success"),
              this.translateService.instant("Xuất hoá đơn thành công")
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Không tìm thấy file hoá đơn")
            );
          }
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Xuất hoá đơn thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }

  onChangeShip() {
    this.submitted = true;
    if (this.formData.invalid) {
      return;
    }

    const data = {
      id: this.formData.value.id,
      recipient_name: this.formData.value.recipient_name,
      phone_number: this.formData.value.phone_number,
      province: this.formData.value.province?.PROVINCE_NAME,
      province_id: this.formData.value.province?.PROVINCE_ID,
      district: this.formData.value.district?.DISTRICT_NAME,
      district_id: this.formData.value.district?.DISTRICT_ID,
      ward: this.formData.value.ward?.WARDS_NAME,
      ward_id: this.formData.value.ward?.WARDS_ID,
      specific_address: this.formData.value.specific_address,
    };

    this.apiService
      .postItem("customer-orders/update-delivery-info", data)
      .subscribe({
        // this.apiService.postItem('customer-orders/update-delivery-info', data).subscribe({
        next: (res: any) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Đổi luồng thành công")
          );
          this.fetchData();
          this.modalService.dismissAll();
          this.fetchDataLog();
          this.fetchDataDevive();
        },
        error: (e) => {
          if (e) {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant(e)
            );
          } else {
            this.apiService.showToastMobile(
              "error",
              this.translateService.instant("Đổi luồng thất bại")
            );
          }
          this.eventService.setLoading(false);
        },
      });
  }
  reasonCancelDeviceList = [
    { code: "LOST", name: "Mất thiết bị" },
    { code: "CANCEL_AUTO_RENEW", name: "Hủy không gia hạn" },
    { code: "OTHER", name: "Lý do khác" },
  ];

  reuseCategoryOptions = [
    { value: "REUSABLE", label: "Có thể tái sử dụng", description: "" },
    { value: "WARRANTY_ONLY", label: "Chỉ dùng cho bảo hành", description: "" },
  ];
  readonly maxRecalledImageSize = 8 * 1024 * 1024;
  readonly maxRecalledVideoSize = 50 * 1024 * 1024;

  onRecalledChange(isRecalled: boolean): void {
    const controls = [
      "reuse_category",
      "reuse_category_reason",
      "returned_date",
      "recalled_image",
      "recalled_video",
    ];

    controls.forEach((name) => {
      const control = this.formData.get(name);
      control.setValidators(isRecalled ? [Validators.required] : []);
      if (!isRecalled) {
        control.setValue(null);
      }
      control.updateValueAndValidity();
    });
    this.formData.get("is_recalled").setValue(isRecalled ? 1 : 0);
  }

  onCancelReasonChange(reason: string): void {
    if (!reason || reason === "LOST") {
      this.onRecalledChange(false);
    }
  }

  getReuseCategoryDescription(value: string): string {
    return this.reuseCategoryOptions.find((option) => option.value === value)?.description || "";
  }

  getReuseCategoryLabel(value: string): string {
    return this.reuseCategoryOptions.find((option) => option.value === value)?.label || value || "--";
  }

  onRecalledFileChange(event: Event, controlName: "recalled_image" | "recalled_video"): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    const isImage = controlName === "recalled_image";
    const maxSize = isImage ? this.maxRecalledImageSize : this.maxRecalledVideoSize;
    const allowedExtension = isImage
      ? /\.(jpe?g|png|gif|webp|bmp)$/i
      : /\.(mp4|mov|avi|mkv|webm|m4v)$/i;
    const hasExpectedType = file &&
      (file.type.startsWith(isImage ? "image/" : "video/") || allowedExtension.test(file.name));

    if (!file) {
      this.formData.get(controlName).setValue(null);
      return;
    }

    if (!hasExpectedType) {
      this.apiService.showToastMobile("error", `Vui lòng chọn tệp ${isImage ? "hình ảnh" : "video"} hợp lệ.`);
      input.value = "";
      this.formData.get(controlName).setValue(null);
      return;
    }

    if (file.size > maxSize) {
      this.apiService.showToastMobile("error", `${isImage ? "Ảnh" : "Video"} không được vượt quá ${isImage ? "8MB" : "50MB"}.`);
      input.value = "";
      this.formData.get(controlName).setValue(null);
      return;
    }

    this.formData.get(controlName).setValue(file);
    this.formData.get(controlName).markAsTouched();
  }

  canSubmitUnpairDevice(): boolean {
    if (!this.formData) {
      return false;
    }

    const data = this.formData.getRawValue();
    const hasBaseFields = !!data.serial_number && !!data.reason && !!data.note;
    const isRecalled = data.is_recalled === 1 && data.reason !== "LOST";
    const hasRecalledFields = !isRecalled ||
      (!!data.reuse_category &&
        !!data.reuse_category_reason &&
        !!data.returned_date &&
        !!data.recalled_image &&
        !!data.recalled_video);

    return hasBaseFields && hasRecalledFields;
  }

  unPairDevice() {
    this.submitted = true;
    const data = this.formData.getRawValue();
    if (!this.canSubmitUnpairDevice()) {
      [
        "reason",
        "note",
        "reuse_category",
        "reuse_category_reason",
        "returned_date",
        "recalled_image",
        "recalled_video",
      ]
        .forEach((name) => this.formData.get(name)?.markAsTouched());
      return;
    }

    let apiUrl = "";
    const dataPost = new FormData();

    if (data.device_link_request_id) {
      apiUrl = "devices/cs/cancel-device";
      dataPost.append("customerOrderId", String(this.id));
      dataPost.append("deviceLinkRequestId", String(data.device_link_request_id));
    } else {
      apiUrl = "devices/unpair-device";
      dataPost.append("orderId", String(this.id));
    }

    dataPost.append("serialNumber", data.serial_number);
    dataPost.append("reason", data.reason);
    dataPost.append("note", data.note || "");
    const isRecalled = data.is_recalled === 1 && data.reason !== "LOST";
    dataPost.append("isRecalled", isRecalled ? "1" : "0");

    if (isRecalled) {
      dataPost.append("reuseCategory", data.reuse_category);
      dataPost.append("reuseCategoryReason", data.reuse_category_reason);
      dataPost.append("returnedDate", this.formatDateForApi(data.returned_date));
      dataPost.append("image", data.recalled_image, data.recalled_image.name);
      dataPost.append("video", data.recalled_video, data.recalled_video.name);
    }

    this.eventService.setLoading(true);

    this.apiService.postItem(apiUrl, dataPost).subscribe({
      next: () => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Hủy liên kết thành công")
        );
        this.fetchData();
        this.fetchDataLog();
        this.modalService.dismissAll();
        this.eventService.setLoading(false);
      },
      error: (e) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant(e || "Huỷ liên kết thất bại")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  deviceIssueType: string = '';
  deviceIssueNote: string = '';
  selectedDeviceForIssue: any = null;
  deviceLinkHistory: any[] = [];
  deviceLinkHistorySerial = "";
  orderDeviceLinkHistory: any[] = [];
  deviceRecallEvidence: any = null;
  deviceRecallEvidenceSerial = "";
  recallEvidenceObjectUrls: Record<string, string> = {};
  recallEvidencePreviewUrl: SafeUrl | null = null;
  recallEvidenceZoom = 1;

  isDeviceRecallLog(log: any): boolean {
    return (
      String(log?.action || "").toLowerCase().includes("đã hủy gắn thiết bị") &&
      !!this.getDeviceSerialNumberFromLog(log?.action)
    );
  }

  getDeviceSerialNumberFromLog(action: string): string | null {
    const matchedSerial = String(action || "").match(/:::\s*([^\s]+)/);
    return matchedSerial ? matchedSerial[1] : null;
  }

  hasRecallEvidence(log: any): boolean {
    return !!log?.hasRecallEvidence;
  }

  private checkRecallEvidenceForLogs(logs: any[]): void {
    const serialNumbers = [...new Set(
      logs
        .filter((log) => this.isDeviceRecallLog(log))
        .map((log) => this.getDeviceSerialNumberFromLog(log.action))
        .filter(Boolean)
    )] as string[];

    if (!serialNumbers.length) {
      return;
    }

    forkJoin(
      serialNumbers.map((serialNumber) =>
        this.apiService
          .getList(
            `device-recall-evidences?customerOrderId=${encodeURIComponent(String(this.id))}&serialNumber=${encodeURIComponent(serialNumber)}`
          )
          .pipe(
            map((res: any) => ({
              serialNumber,
              hasEvidence: (() => {
                const metadata = res?.metadata || res?.data?.metadata || {};
                return (
                  Number(metadata.customerOrderId) === Number(this.id)
                  && metadata.serialNumber === serialNumber
                );
              })(),
            })),
            catchError(() => of({ serialNumber, hasEvidence: false }))
          )
      )
    ).subscribe((results: { serialNumber: string; hasEvidence: boolean }[]) => {
      const evidenceBySerial = new Map(results.map((result) => [result.serialNumber, result.hasEvidence]));
      this.listDataLog.forEach((log: any) => {
        const serialNumber = this.getDeviceSerialNumberFromLog(log.action);
        log.hasRecallEvidence = this.isDeviceRecallLog(log)
          && !!serialNumber
          && evidenceBySerial.get(serialNumber) === true;
      });
    });
  }

  showDeviceRecallEvidence(log: any, content: any): void {
    const serialNumber = this.getDeviceSerialNumberFromLog(log?.action);
    if (!serialNumber || !this.id) {
      return;
    }

    this.deviceRecallEvidence = null;
    this.deviceRecallEvidenceSerial = serialNumber;
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        `device-recall-evidences?customerOrderId=${encodeURIComponent(String(this.id))}&serialNumber=${encodeURIComponent(serialNumber)}`
      )
      .subscribe({
        next: (res: any) => {
          this.deviceRecallEvidence = res?.metadata || res?.data?.metadata || null;
          const evidences = this.deviceRecallEvidence?.evidences || [];

          console.log("[DeviceRecallEvidence] API response:", res);
          console.log("[DeviceRecallEvidence] API host and resolved media URLs:", {
            apiHost: environment.host,
            apiOrigin: new URL(environment.host).origin,
            customerOrderId: this.id,
            serialNumber,
          });
          console.table(
            evidences.map((evidence: any) => ({
              fileType: evidence.fileType,
              fileUrl: evidence.fileUrl,
              resolvedUrl: this.getRecallEvidenceFileUrl(evidence.fileUrl),
            }))
          );

          this.loadRecallEvidenceObjectUrls(evidences).subscribe(() => {
            this.modalService.open(content, {
              centered: true,
              scrollable: true,
              size: "xl",
              windowClass: "recall-evidence-modal",
            });
            this.eventService.setLoading(false);
          });
        },
        error: (error) => {
          const message = error?.status === 404
            ? "Chưa có minh chứng thu hồi thiết bị cho lần thao tác này"
            : "Không thể tải minh chứng thu hồi thiết bị";
          this.apiService.showToastMobile("error", this.translateService.instant(message));
          this.eventService.setLoading(false);
        },
      });
  }

  getRecallEvidenceFileUrl(fileUrl: string): string {
    if (!fileUrl) {
      return "";
    }

    // fileUrl is returned as an API-relative path, e.g. /uploads/...
    // URL resolves it against the API origin, excluding the /api/v1 path.
    return new URL(fileUrl, environment.host).toString();
  }

  getRecallEvidenceMediaUrl(evidence: any): SafeUrl {
    const mediaUrl = this.recallEvidenceObjectUrls[evidence?.fileUrl]
      || this.getRecallEvidenceFileUrl(evidence?.fileUrl);

    // Blob URLs are created from authenticated HttpClient responses above.
    // Mark them safe so Angular does not rewrite them to unsafe:blob....
    return this.sanitizer.bypassSecurityTrustUrl(mediaUrl);
  }

  openRecallEvidenceImagePreview(evidence: any, content: any): void {
    this.recallEvidencePreviewUrl = this.getRecallEvidenceMediaUrl(evidence);
    this.recallEvidenceZoom = 1;
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: "xl",
      windowClass: "recall-evidence-preview-modal",
    });
  }

  changeRecallEvidenceZoom(step: number): void {
    this.recallEvidenceZoom = Math.min(3, Math.max(0.25, Number((this.recallEvidenceZoom + step).toFixed(2))));
  }

  resetRecallEvidenceZoom(): void {
    this.recallEvidenceZoom = 1;
  }

  private loadRecallEvidenceObjectUrls(evidences: any[]) {
    Object.keys(this.recallEvidenceObjectUrls).forEach((fileUrl) => {
      URL.revokeObjectURL(this.recallEvidenceObjectUrls[fileUrl]);
    });
    this.recallEvidenceObjectUrls = {};

    if (!evidences.length) {
      return of([]);
    }

    return forkJoin(
      evidences.map((evidence) =>
        this.http.get(this.getRecallEvidenceFileUrl(evidence.fileUrl), { responseType: "blob" }).pipe(
          tap((file) => {
            const objectUrl = URL.createObjectURL(file);
            this.recallEvidenceObjectUrls[evidence.fileUrl] = objectUrl;
            console.log("[DeviceRecallEvidence] Loaded authenticated media Blob:", {
              fileUrl: evidence.fileUrl,
              objectUrl,
              type: file.type,
              size: file.size,
            });
          }),
          catchError((error) => {
            console.error("[DeviceRecallEvidence] Unable to download media Blob:", {
              fileUrl: evidence.fileUrl,
              resolvedUrl: this.getRecallEvidenceFileUrl(evidence.fileUrl),
              error,
            });
            return of(null);
          })
        )
      )
    );
  }

  onRecallEvidenceMediaError(evidence: any, event: Event): void {
    const mediaElement = event.target as HTMLMediaElement;
    console.error("[DeviceRecallEvidence] Unable to load media:", {
      fileType: evidence.fileType,
      fileUrl: evidence.fileUrl,
      resolvedUrl: this.getRecallEvidenceMediaUrl(evidence),
      currentSrc: mediaElement.currentSrc || mediaElement.src,
      networkState: mediaElement.networkState,
      error: mediaElement.error,
    });
  }

  showOrderDeviceLinkHistory(content: any): void {
    if (!this.id) {
      return;
    }

    this.orderDeviceLinkHistory = [];
    this.eventService.setLoading(true);
    this.apiService
      .getList(`customer-orders/${this.id}/device-link-history`)
      .subscribe({
        next: (res: any) => {
          const metadata = res?.metadata || res?.data?.metadata || {};
          this.orderDeviceLinkHistory = metadata.history || [];
          this.modalService.open(content, {
            centered: true,
            scrollable: true,
            size: "lg",
          });
          this.eventService.setLoading(false);
        },
        error: () => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Không thể tải lịch sử liên kết thiết bị")
          );
          this.eventService.setLoading(false);
        },
      });
  }

  showDeviceLinkHistory(device: any, content: any): void {
    const serialNumber = device?.serial_number;
    if (!serialNumber) {
      return;
    }

    this.deviceLinkHistory = [];
    this.deviceLinkHistorySerial = serialNumber;
    this.eventService.setLoading(true);
    this.apiService
      .getList(`device-stocks/${encodeURIComponent(serialNumber)}/link-history`)
      .subscribe({
        next: (res: any) => {
          const metadata = res?.metadata || res?.data?.metadata || {};
          this.deviceLinkHistory = metadata.history || [];
          this.modalService.open(content, {
            centered: true,
            scrollable: true,
            size: "xl",
          });
          this.eventService.setLoading(false);
        },
        error: (error) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(error || "Không thể tải lịch sử liên kết thiết bị")
          );
          this.eventService.setLoading(false);
        },
      });
  }

  onMarkDeviceIssue(data: any, content: any) {
    this.deviceIssueType = '';
    this.deviceIssueNote = '';
    this.selectedDeviceForIssue = data;
    this.modalService.open(content, {
      centered: true,
      scrollable: true,
      size: 'lg',
    });
  }

  markDeviceIssue() {
    const dataPost: any = {
      type: this.deviceIssueType,
      serialNumber: this.selectedDeviceForIssue.serial_number,
    };
    if (this.deviceIssueNote?.trim()) {
      dataPost.note = this.deviceIssueNote.trim();
    }
    this.apiService
      .postItem(`customer-orders/${this.id}/mark-device-issue`, dataPost)
      .subscribe({
        next: () => {
          this.apiService.showToastMobile(
            this.translateService.instant('success'),
            this.translateService.instant('Đánh dấu thành công')
          );
          this.modalService.dismissAll();
          this.fetchData();
          this.fetchDataLog();
        },
        error: (e) => {
          this.apiService.showToastMobile(
            'error',
            this.translateService.instant(e || 'Đánh dấu thất bại')
          );
        },
      });
  }

  listDeviceLink;
  onSearchChange(searchTerm) {
    this.fetchDataDevice(searchTerm?.term);
    console.log(searchTerm?.term);
  }
  fetchDataDevice(device) {
    this.apiService
      .getList("device-stock?status=0&serial_number=" + device)
      .subscribe({
        next: (res) => {
          this.listDeviceLink = res.metadata["deviceStocks"]
            ? res.metadata["deviceStocks"]
            : [];
        },
      });
  }
  pairDevices() {
    const data = this.formData.value;
    const dataPost = {
      orderId: this.id,
      serialNumber: data.serial_number,
    };
    this.apiService.postItem("devices/pair-device", dataPost).subscribe({
      next: (res) => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Liên kết thành công")
        );
        this.modalService.dismissAll();
        this.eventService.setLoading(false);
        this.fetchData();
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Liên kết thất bại")
          );
        }
        this.eventService.setLoading(false);
      },
    });
  }
  handleCancel() {
    Swal.fire({
      title: this.translateService.instant("FORM.Warning"),
      text: this.translateService.instant("Bạn có chắc chắn hủy gói"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#34c38f",
      cancelButtonColor: "#ff3d60",
      confirmButtonText: this.translateService.instant("FORM.WarningConfirm"),
      cancelButtonText: this.translateService.instant("FORM.Cancel"),
    }).then((result) => {
      if (result.value) {
        this.apiService
          .postItem("cs/customer-orders/cancel/" + this.id, {})
          .subscribe({
            next: (res: any) => {
              this.apiService.showToastMobile(
                this.translateService.instant("success"),
                this.translateService.instant("Hủy gói thành công")
              );
            },
            error: (e) => {
              if (e == "Customer already has this package qr paybox") {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant(
                    "Tài khoản đã sử dụng gói dịch vụ"
                  )
                );
              } else {
                this.apiService.showToastMobile(
                  "error",
                  this.translateService.instant("Hủy gói thất bại")
                );
              }
              this.eventService.setLoading(false);
            },
          });
      }
    });
  }
  searching = false;

  submitFilter() {
    this.getByPhone();
  }

  phoneResultsName: string = "";
  phoneResultsAddress: string = "";
  filterNameTable = "users/get-by-phone";
  getByPhone() {
    const requestData = {
      phone: this.phone,
    };
    this.eventService.setLoading(true);
    this.apiService
      .getbyphone(
        this.filterNameTable,
        requestData
        // + `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
      )
      .subscribe({
        next: (res) => {
          const dataPhone = res["data"];
          this.phoneResultsName = dataPhone["full_name"]
            ? dataPhone["full_name"]
            : "";
          this.phoneResultsAddress = dataPhone["address"]
            ? dataPhone["address"]
            : "";

          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          Toast.fire({
            icon: "success",
            title: this.translateService.instant("FORM.Success"),
          });
          this.searching = true;
          this.eventService.setLoading(false);
        },
        error: (e) => {
          const Toast = Swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 2000,
            timerProgressBar: true,
          });
          Toast.fire({
            icon: "error",
            title: this.translateService.instant("Số điện thoại không tồn tại"),
          });
          this.eventService.setLoading(false);
          // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
          // this.eventService.setLoading(false)
        },
      });
  }
  makeForm2(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      // id: [data.id],
      // imei : [data.imei, [Validators.required]],
      // description: [data.description],
      // price: [data.price || 0, [Validators.required]],
      // model : [data.model, [Validators.required]],
      // image_url: [data.image_url, [Validators.required]],
      device_id: [data.device_id, [Validators.required]],
      bankaccount_id: [data.bankaccount_id, [Validators.required]],
      // type: [data.type, [Validators.required]],
      // currency: [data.currency || 'VND'],
    });
  }

  makeFormMember(d?) {
    let data = d ? d : <any>{};
    return this.formBuilder.group({
      phone: [data.phone, [Validators.required]],
      type: [data.type, [Validators.required]],
      // currency: [data.currency || 'VND'],
      workspace_id: this.activatedRoute.snapshot.params["id"],
    });
  }

  allMoney: number = 0;

  list_serial_number = [];

  openModalLink(contentLink) {
    this.submitted = false;
    this.formData2 = this.makeForm2({ language: [{}] });
    let a = this.modalService.open(contentLink, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  tableName3 = "bankaccounts/active";
  list_id_account = [];
  listDataBankAccount = [];
  submitted: boolean;
  tableName4 = "workspaces/device-and-bankaccount";

  fetchDataBankAccount(params = "") {
    params = "&order=updated_at&direction=desc";
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableName3 +
          `?page=${this.pageIndex}&limit=${this.pageSize}${params}`
      )
      .subscribe({
        next: (res) => {
          this.listDataBankAccount = res["bankaccounts"]
            ? res["bankaccounts"]
            : [];

          this.listDataBankAccount.forEach((item) => {
            if (item["id"]) {
              this.list_id_account.push(item["id"]);
            }
          });

          this.totalCount = res.length;
          // // this.totalCount = res.meta.tota
          this.eventService.setLoading(false);
        },
      });
  }
  deviceChange() {
    const data = this.formData.value;
    let apiUrl = "";
    let dataPost: any = {};
    if (data.device_link_request_id) {
      // Trường hợp có device_link_request_id (yêu cầu thay đổi đã tạo trước đó)
      apiUrl = "devices/cs/change-device";
      dataPost = {
        customerOrderId: +this.id,
        deviceLinkRequestId: data.device_link_request_id,
        oldSerialNumber: data.serial_number,
        newSerialNumber: data.serial_number_new,
        note: data.note,
        reason: data.reason,
      };
    } else {
      // Trường hợp không có device_link_request_id → thay đổi trực tiếp
      apiUrl = "cs/device-subscription/change-device";
      dataPost = {
        orderId: this.id,
        serialNumber: data.serial_number,
        serialNumberNew: data.serial_number_new,
        note: data.note,
        reason: data.reason,
      };
    }
    this.apiService.postItem(apiUrl, dataPost).subscribe({
      next: (res: any) => {
        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Thay đổi thành công")
        );
        this.modalService.dismissAll();
        this.fetchData();
        this.fetchDataLog();
        this.fetchDataDevive();
        this.eventService.setLoading(false);
      },
      error: (e) => {
        this.apiService.showToastMobile(
          "error",
          this.translateService.instant(e || "Thay đổi thất bại")
        );
        this.eventService.setLoading(false);
      },
    });
  }

  changeSim() {
    const data = this.formData.value;
    const dataPost = {
      sim4g_imsi: data.sim4g_imsi,
      network_provider: data.network_provider,
    };
    this.apiService
      .changeStatus("device-stocks/admin", data.serial_number, dataPost)
      .subscribe({
        next: (res) => {
          this.apiService.showToastMobile(
            this.translateService.instant("success"),
            this.translateService.instant("Thay đổi thành công")
          );
          this.modalService.dismissAll();
          this.fetchData();
          this.fetchDataLog();
          this.fetchDataDevive();
          this.eventService.setLoading(false);
        },
        error: (e) => {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Thay đổi thất bại")
          );
          this.eventService.setLoading(false);
        },
      });
  }
  saveData2() {
    this.submitted = true;
    if (this.formData2.valid) {
      const value = this.formData2.value;
      // value['status'] = value['status'] == true ? 0 : 1
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService.editItem(this.tableName4, value.id, value).subscribe({
          next: (res) => {
            this.submitted = false;
            this.formData2.reset();
            this.fetchDataBankAccount();
            this.modalService.dismissAll();
            this.apiService.showToast(
              this.translateService.instant("FORM.Success"),
              this.translateService.instant("FORM.SuccessMessage"),
              "success"
            );
            this.eventService.setLoading(false);
          },
          error: (e) => {
            this.apiService.showToast(
              this.translateService.instant("FORM.Error"),
              this.translateService.instant("Thêm không thành công"),
              "error"
            );
            this.eventService.setLoading(false);
          },
        });
      } else {
        this.apiService.addItem(this.tableName4, value).subscribe({
          next: (res) => {
            this.fetchDataBankAccount();
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });

            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("Thêm không thành công"),
            });
            this.eventService.setLoading(false);
            // this.apiService.showToast(this.translateService.instant('FORM.Error'), this.translateService.instant('FORM.userNotExist'), 'error')
            // this.eventService.setLoading(false)
          },
        });
      }
    } else {
      console.log("invalid", this.formData2);
      Object.values(this.formData2.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  get form() {
    return this.formDataMember.controls;
  }

  formDataMember: FormGroup;
  listType = ["Trưởng nhóm", "Phó cửa hàng", "Thành viên"];
  tableNameMember = "members";

  openModalMember(contentMember: any) {
    this.submitted = false;
    this.formDataMember = this.makeFormMember({ language: [{}] });
    let a = this.modalService.open(contentMember, {
      centered: true,
      scrollable: true,
      size: "lg",
    });
  }

  listDataMember = [];

  fetchDataMember() {
    // params = '&order=updated_at&direction=desc'
    this.eventService.setLoading(true);
    this.apiService
      .getList(
        this.tableNameMember +
          `?page=${this.pageIndex}&limit=${this.pageSize}${this.params}`
      )
      .subscribe({
        next: (res) => {
          // this.listData = res.members
          this.listDataMember = res["members"] ? res["members"] : [];
          this.totalCount = res["pagination"]["totalCount"]
            ? res["pagination"]["totalCount"]
            : "";
          this.eventService.setLoading(false);
        },
      });
  }

  saveDataMember() {
    this.submitted = true;
    if (this.formDataMember.valid) {
      const value = this.formDataMember.value;
      // value['status'] = value['status'] == true ? 0 : 1
      // value['prices'][0]['condition'] = 1
      // value['prices'][1]['condition'] = 2
      // value['price']= value['prices']
      this.eventService.setLoading(true);
      if (value.id) {
        this.apiService
          .editItem(this.tableNameMember, value.id, value)
          .subscribe({
            next: (res) => {
              this.submitted = false;
              this.formDataMember.reset();
              this.fetchDataMember();
              this.modalService.dismissAll();
              this.apiService.showToast(
                this.translateService.instant("FORM.Success"),
                this.translateService.instant("FORM.SuccessMessage"),
                "success"
              );
              this.eventService.setLoading(false);
            },
            error: (e) => {
              this.apiService.showToast(
                this.translateService.instant("FORM.Error"),
                this.translateService.instant("Thêm không thành công"),
                "error"
              );
              this.eventService.setLoading(false);
            },
          });
      } else {
        this.apiService.addItem(this.tableNameMember, value).subscribe({
          next: (res) => {
            this.fetchDataMember();
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "success",
              title: this.translateService.instant("FORM.Success"),
            });
            window.location.reload();
            this.eventService.setLoading(false);
            this.modalService.dismissAll();
          },
          error: (e) => {
            const Toast = Swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 2000,
              timerProgressBar: true,
            });
            Toast.fire({
              icon: "error",
              title: this.translateService.instant("Thêm không thành công"),
            });
            this.eventService.setLoading(false);
          },
        });
      }
    } else {
      console.log("invalid", this.formDataMember);
      Object.values(this.formDataMember.controls).forEach((control) => {
        if (control.status == "INVALID") {
          control.markAsDirty();
          control.updateValueAndValidity({ onlySelf: true });
        }
      });
    }
  }

  deviceCheck() {
    const data = this.formData.value;
    const dataPost = {
      amount: data.serial_number_new,
      mid: data.serial_number,
      orderId: this.id,
    };

    this.apiService.postItem("device-notice", dataPost).subscribe({
      next: (res) => {
        this.fetchDataLog();

        this.apiService.showToastMobile(
          this.translateService.instant("success"),
          this.translateService.instant("Gửi thông báo thành công")
        );
      },
      error: (e) => {
        if (e) {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant(e)
          );
          this.eventService.setLoading(false);
        } else {
          this.apiService.showToastMobile(
            "error",
            this.translateService.instant("Thay đổi thất bại")
          );
          this.eventService.setLoading(false);
        }
      },
    });
  }
}
